import React, { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Input, Label } from 'reactstrap';
import { labelMapping } from '../../utils/constants';
import CommentSearchSelect from './CommentSearchSelect';

const InputCheckControlled = ({ name, rules, section }) => {
  const {
    control,
    setValue,
    formState: { defaultValues },
  } = useFormContext();
  const { field } = useController({ name, control, rules });
  const value = field?.value?.value ?? {};
  const textLabel = name.split('.').pop();

  useEffect(() => {
    if (!field.value) {
      setValue(name, { value: { checked: false, obs: '' } });
    }
  }, [field.value, name, setValue, defaultValues]);

  if (!field.value) {
    return null;
  }

  return (
    <div className="row">
      <div className="col-6">
        <Label>{labelMapping[textLabel]}</Label>
      </div>
      <div className="col-1">
        <Input
          checked={value?.checked ?? false}
          onChange={(e) => {
            field.onChange({
              ...field?.value,
              value: { ...value, checked: e.target.checked },
            });
          }}
          type="checkbox"
        />
      </div>
      <div className="col-5">
        <CommentSearchSelect
          value={value?.obs ?? ''}
          onChange={(selectedValue) => {
            field.onChange({
              ...field?.value,
              value: { ...value, obs: selectedValue },
            });
          }}
          section={section}
          placeholder="Buscar comentario..."
        />
      </div>
    </div>
  );
};

export default InputCheckControlled;
